

const constants = {
   backToLogin: "חזרה למסך הכניסה",
   formName: "newPassword",
   title: "איפוס סיסמה",
   subTitle: "כדי לאפס את הסיסמה צריך למלא את השם משתמש איתו נרשמתם",
}

export default constants